import { Component, inject } from '@angular/core';
import { IonAvatar, IonCard, IonCardContent, IonCardTitle, IonIcon } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { addIcons } from 'ionicons';

import { UserInitialsPipe } from '../../../shared/pipes/user-initials.pipe';
import { GeneralActions } from '../../../shared/redux/general/general.actions';
import { GeneralSelectors } from '../../../shared/redux/general/general.reducer';

@Component({
  selector: 'app-account-card',
  imports: [IonIcon, IonCard, IonCardTitle, IonAvatar, IonCard, IonCardContent, UserInitialsPipe],
  templateUrl: './account-card.html',
  styleUrl: './account-card.scss',
})
export class AccountCard {
  private readonly store = inject(Store);

  // account card
  protected readonly userFullName$$ = this.store.selectSignal(GeneralSelectors.userFullName);
  protected readonly userEMail$$ = this.store.selectSignal(GeneralSelectors.userEMail);
  protected readonly givenName$$ = this.store.selectSignal(GeneralSelectors.givenName);
  protected readonly familyName$$ = this.store.selectSignal(GeneralSelectors.familyName);

  constructor() {
    addIcons({ openExternally: 'assets/icons/open-in-new-icon.svg' });
  }

  handleOpenProfile(): void {
    this.store.dispatch(GeneralActions.openUserProfile());
  }
}
